<template>
  <div>
    <com-dialog title="语音设置" :visible.sync="visible">
      <div>
        <el-form :model="formData" label-width="120px">
          <el-form-item label="播放开关">
            <el-select v-model="formData.open" placeholder="">
              <el-option label="打开" :value="1"></el-option>
              <el-option label="关闭" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="防打扰开关">
            <el-select v-model="formData.value1" placeholder="">
              <el-option label="打开" :value="1"></el-option>
              <el-option label="关闭" :value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="音量">
            <el-select v-model="formData.volume" placeholder="">
              <el-option
                :label="item"
                :value="item"
                v-for="(item, index) in 7"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="" @click="close">取消</el-button>
            <el-button type="primary" @click="confirm">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { voiceSettingByStore } from '@/api/site'

export default {
  data() {
    return {
      visible: false,
      formData: {
        volume: null,
        open: null,
        refStore: ''
      }
    }
  },
  methods: {
    close() {
      this.visible = false
    },
    open(code) {
      console.log('code :>> ', code)
      this.formData.refStore = code
      this.visible = true
    },
    async confirm() {
      const res = await voiceSettingByStore(this.formData)
      if (res) {
        this.$message.success(res.desc)
        this.$emit('onSuccess')
        this.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
